export default "__VITE_ASSET__df3fb1a2__"